export const isBlacklistedUserAgent = () => {
  try {
    const userAgent = window.navigator.userAgent
    const blacklistedPatterns = [/selenium/i, /spider\b/i, /headless/i, /phantomjs/i, /bot\b/i]

    // Normalize the User-Agent string
    const ua = userAgent.toLowerCase()

    // Check for empty or missing User-Agent
    if (!ua || ua.trim() === '') {
      // Optionally, treat empty User-Agent as blacklisted
      return true
    }

    // Check against blacklisted patterns
    for (const pattern of blacklistedPatterns) {
      if (pattern.test(ua)) {
        return true
      }
    }

    return false
  } catch (e) {
    return false
  }
}
